export const LINK = {
    APP_APPLE_STORE: 'https://apps.apple.com/pl/app/freequest-app/id1506187620?l={lang}',
    APP_GOOGLE_STORE: 'https://play.google.com/store/apps/details?id=com.applandeo.freequest',
};

export const getTermsOfUseLink = (lang: string) => `/terms-of-use?lang=${lang?.toUpperCase()}`;
export const getPrivacyPolicyLink = (lang: string) => `/privacypolicy?lang=${lang?.toUpperCase()}`;
